import LanguageOutlinedIcon from "@material-ui/icons/LanguageOutlined";
import { RedirectedApiClientCreate } from "./RedirectedApiClientCreate";

export default {
  icon: LanguageOutlinedIcon,
  create: RedirectedApiClientCreate,
};
